import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import Modal from '../../../../../../../../Modal';
import { OpenableState } from '../../../../../../../../Modal/UseOpenable';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import { ExperienceResource } from '../../../../ExperienceCatalog/Types';
import Body from './Body';

export interface Props {
  close: () => void;
  modalState: OpenableState;
  experienceResource: ExperienceResource;
  experienceStore: LearningDesignExperienceStore;
  store: LearningCollectionEditStore;
}

const undoChangesAndClose = (close: () => void, experienceStore: LearningDesignExperienceStore) => {
  fromEmpty(experienceStore.previouslySelectedIds).do((ids) => experienceStore.setSelectedIds(ids));
  close();
};

const EditDatesModal: React.FC<Props> = ({
  experienceResource,
  modalState,
  close,
  experienceStore,
  store,
}) => {
  switch (modalState.kind) {
    case 'open':
      return (
        <Modal
          close={() => undoChangesAndClose(close, experienceStore)}
          title={<></>}
          modalWidth="h-3/5 w-2/5"
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <Body
            experienceResource={experienceResource}
            close={close}
            experienceStore={experienceStore}
            store={store}
          />
        </Modal>
      );
    case 'closed':
      return <></>;
  }
};

export default observer(EditDatesModal);
